import { CommonModule } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MediaImageComponent } from "./component/image/component";
import { MediaLibraryComponent } from "./component/library/component";
import { MediaUploadComponent } from "./component/upload/component";
import { MediaControl } from "./control/media/component";
import { MediaLibraryDialog } from "./dialog/library/component";
import { MediaUploadDialog } from "./dialog/upload/component";
import { MediaRoutingModule } from "./media-routing.module";
import { MediaService } from "./media.service";
import { MediaDevScreen } from "./screen/dev/component";

@NgModule({
  imports: [
    MediaRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
  ],
  providers: [
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    MediaService,
  ],
  declarations: [
    MediaDevScreen,
    MediaControl,
    MediaLibraryComponent,
    MediaUploadComponent,
    MediaImageComponent,
    MediaLibraryDialog,
    MediaUploadDialog,
  ],
  exports: [
    MediaControl,
    MediaImageComponent,
    MediaLibraryComponent,
  ],
})
export class MediaModule {}